import { useCallback, useEffect, useRef, useState } from 'react';
// utils
import { creaApi } from '../utils/api';
// components
import Label from './Label';

// ----------------------------------------------------------------------

// Evento global para forçar a atualização do badge (ex.: após aprovar/rejeitar).
export const PENDING_REFRESH_EVENT = 'pending-candidates:refresh';
export const refreshPendingBadge = () => window.dispatchEvent(new Event(PENDING_REFRESH_EVENT));

// Badge que destaca, no menu lateral, quantos candidatos estão aguardando aprovação.
export default function PendingCandidatesBadge() {
  const [count, setCount] = useState(0);
  const mountedRef = useRef(true);

  const fetchCount = useCallback(async () => {
    try {
      const { data } = await creaApi.get(
        '/candidate/listAll?isPagination=1&includeInvisible=1&approvalStatus=PENDING&limit=1'
      );
      if (mountedRef.current) setCount(data?.totalItens ?? 0);
    } catch (error) {
      // Falha silenciosa: badge é apenas informativo.
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetchCount();
    window.addEventListener(PENDING_REFRESH_EVENT, fetchCount);
    return () => {
      mountedRef.current = false;
      window.removeEventListener(PENDING_REFRESH_EVENT, fetchCount);
    };
  }, [fetchCount]);

  if (!count) return null;

  return <Label color="error">{count}</Label>;
}
